// @flow
import * as React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import Icon from '../../icon/react/Icon';

const Loader = ({
  text = t('Inhalte werden geladen.'),
}: {
  text?: string,
}): React.MixedElement => (
  <div className="loader">
    <p className="loader__text">{text}</p>
    <Icon icon="list-loader" className="loader__icon" />
  </div>
);

export default Loader;
